import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const sectionTitle: SxStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: (p) => p.palette.primary[100],
  color: (p) => p.palette.primary[500],
  borderRadius: (p) => p.spacing(1),
  marginBottom: (p) => p.spacing(1),
  py: (p) => p.spacing(0.5),
  width: (p) => p.spacing(15),
};
